import { useReactToPrint } from "react-to-print";
import {
  Button,
  Loading,
  MiniPrintLayoutFaturamento,
} from "../../../../components";
import { useRef, useState } from "react";
import {
  ImpressoraService,
  notification,
  PedidosService,
} from "../../../../services";
import MainPrintLayout from "./MainPrintLayout";
import { useImportContext } from "../../../../contexts/import.context";
import EnvioWhatsappDialog from "./dialogComponents/EnvioWhatsappDialog";
import { responseErros, voltar } from "../../../../utils";

const ButtonMenu = ({
  id,
  data,
  onClickCancelarPedido,
  openDialogEnvioWhatsapp,
  setOpenDialogEnvioWhatsapp,
  configuracoes,
}) => {
  const { initialCollapses } = useImportContext();
  const [isImpressaoA4, setIsImpressaoA4] = useState(true);
  const [loading, setLoading] = useState(false);
  const pedidosService = new PedidosService();
  const impressoraService = new ImpressoraService();
  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef?.current,
    pageStyle: `
        @page {
            size: auto;
            margin: 8mm;
        }
    `,
  });

  async function buscarDanfeSecundaria() {
    setLoading(true);
    const result = await pedidosService.pdfSecundario(data);
    setLoading(false);
    if (!result.isAxiosError) {
      if (configuracoes?.impressaoDiretaPedidos) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function print(base64Pdf) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      const body = {
        base64Pdf,
        printerName: configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site"
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  const escolhaImpressao = async () => {
    const retornoAlerta = await notification.confirmacaoGenericos({
      title: "Selecione um modelo de impressão",
      icon: "info",
      confirmButtonText: `
        <i class="ph-fill ph-article" style="font-size:40px; color: white;"></i> <p style="margin: 0">A4</p>
      `,
      cancelButtonText: `
        <i class="ph-fill ph-scroll" style="font-size:40px; color: white;"></i> <p style="margin: 0">80mm</p>
      `,
      showCancelButton: true,
    });
    setLoading(true);
    if (retornoAlerta.isConfirmed) {
      setIsImpressaoA4(true);
      setTimeout(() => {
        setLoading(false);
        handlePrint();
        if (!id) {
          initialCollapses();
          voltar();
        }
      }, 1000);
      return;
    }
    if (retornoAlerta.dismiss === "cancel") {
      setIsImpressaoA4(false);
      setTimeout(async () => {
        setLoading(false);
        await buscarDanfeSecundaria();
        if (!id) {
          initialCollapses();
          voltar();
        }
      }, 1000);
      return;
    }
    setLoading(false);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className={!id && "d-none"}>
        <Button
          variant="outlined"
          className="mb-1"
          size="small"
          color="primary"
          onClick={onClickCancelarPedido}
        >
          Cancelar Pedido
        </Button>
        <div style={{ position: "absolute", left: "-10000px", top: 0 }}>
          <div ref={componentRef}>
            {isImpressaoA4 ? (
              <MainPrintLayout data={data} />
            ) : (
              <MiniPrintLayoutFaturamento
                data={data}
                descricaoTipoDocumento="pedido"
              />
            )}
          </div>
        </div>
        <Button
          id="botaoMenuAction"
          onClick={escolhaImpressao}
          size="small"
          sx={{ borderRadius: 50 }}
        >
          <i className="ph-fill ph-printer" style={{ fontSize: 18 }}></i>
        </Button>
        {/* <IconButton
          onClick={() => setOpenDialogEnvioWhatsapp(true)}
          size="small"
          sx={{ marginLeft: 2 }}
        >
          <i
            className="ph-fill ph-whatsapp-logo"
            style={{ fontSize: 18, color: "#48A34C" }}
          ></i>
        </IconButton> */}
      </div>
      <EnvioWhatsappDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        data={data}
        initialCollapses={initialCollapses}
      />
      <Loading loading={loading} />
    </div>
  );
};

export default ButtonMenu;
